import React from 'react'
import PropTypes from 'prop-types'

const ExportHeader = ({ title, icon, iconAlt, cancelUrl }) => (
  <div className="modal-header bg-light border-bottom-0 py-2 d-flex align-items-center">
    <h2 className="modal-title text-dark mb-0 d-flex align-items-center">
      <img
        src={icon}
        className="d-flex img-fluid mr-2"
        alt={iconAlt}
        style={{
          maxHeight: '2rem',
          maxWidth: '100%',
          height: 'auto',
          width: 'auto'
        }}
      />
      {' '}
      {title}
    </h2>
    <a
      href={cancelUrl}
      className="btn btn-link text-dark bg-white border"
    >
      <i className="fas fa-reply pr-2" />
      {' '}
      Annuler
    </a>
  </div>
)

ExportHeader.propTypes = {
  cancelUrl: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default ExportHeader